import { css } from '@emotion/css';
import { N0, N50, primary, primaryBackground, lightGrey } from '@assets/colors';

export const styCompareBtn = isCompareModeActive => css`
  height: 32px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  width: 146px;
  margin-left: auto;
  ${isCompareModeActive && `color: ${primary} !important;`}
  ${isCompareModeActive && `outline-color: ${primary} !important;`}
  ${isCompareModeActive && `border-color: ${primary} !important;`}
  :focus {
    border: none;
    outline: none;
  }
`;

const styles = {
  button: {
    borderRadius: 4,
    padding: 8,
    textAlign: 'center',
    cursor: 'pointer',
  },
  text: {
    color: '#333',
  },
  buttonHover: {
    height: 44,
    borderRadius: 4,
    background: '#efefef',
  },
  buttonIcon: {
    width: 25,
    height: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: 4,
  },
  buttonIconHover: {
    background: '#efefef',
    width: 25,
    height: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: 4,
  },
  buttonRounded: {
    borderRadius: 16,
    borderStyle: 'solid',
    borderWidth: 1,
    textAlign: 'center',
    cursor: 'pointer',
  },
  buttonBorder: {
    borderRadius: 4,
    borderStyle: 'solid',
    borderWidth: 1,
    textAlign: 'center',
    borderColor: N50,
    backgroundColor: N0,
    color: lightGrey,
    cursor: 'pointer',
  },
  buttonText: {
    fontSize: 14,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.71,
    letterSpacing: 'normal',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
  buttonTextHover: {
    fontSize: 14,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.71,
    letterSpacing: 'normal',
    background: N50,
    border: 'none',
    cursor: 'pointer',
  },
  disabled: {
    backgroundColor: primaryBackground,
    borderRadius: 4,
    padding: 8,
    textAlign: 'center',
    cursor: 'not-allowed',
    border: `solid 1px ${primaryBackground}`,
  },
};

export default styles;
